<template>
  <el-select ref="main" class="l-tree-select" :popper-class="`l-tree-select-popper ${popperClass}`" :size="size" :clearable="clearable" @visible-change="handleVisibleChange"
    :value="labelShow" :placeholder="placeholder" :disabled="disabled" @click.native="initScroll" @clear="handleClear">
    <slot name="prefix" slot="prefix">

    </slot>
    <div v-if="filter" class="flex" style="padding:8px 8px 0 8px;margin:0;position: sticky;width: 100%;background: #FFF;top: 0;left: 0;z-index: 99;">
      <el-input size="mini" :placeholder="$t('请输入关键字')" v-model="filterText"></el-input>
      <el-button v-if="isCanAddDataItem" :size="size" type="text" icon="el-icon-plus" @click.stop="add">{{$t('新增')}}</el-button>
    </div>
    <el-option :value="value2">
      <VueEasyTree ref="tree" height="222px"  :itemSize="40" :keeps="8" style="height: 230px;padding-top: 8px;overflow: auto;" class="l-tree-option" :filter-node-method="filterNode"
        :expand-on-click-node="false" :data="options" :default-expand-all="defaultExpandAll && !lazy" :lazy="lazy"
        :load="handleTreeLoad" :node-key="valueKey" :current-node-key="value2" :props="treeProps"
        @node-click.self="handleNodeClick" @check="handleNodeCheck">
        <div slot-scope="{ node, data }" :class="{'disabled':data.disabled || disabledList.includes(data[disabledKey])}">
          <i v-if="data.icon" :class="data.icon"></i>
          {{ node.data[labelKey] }}
          <slot name="treeBottom" v-bind="{...node.data}">

          </slot>
        </div>
      </VueEasyTree>
    </el-option>
  </el-select>
</template>
<script>
import { SHOW_SPLIT } from '@util/variable';
import { validatenull } from '@util/validate';
import VueEasyTree from '@wchbrad/vue-easy-tree';
function bindEvent(safe, name, event) {
  typeof safe[name] === 'function' && safe[name]({ value: safe.value, column: safe.column })
  safe.$emit(name, safe.value, event)
}
export default {
  name: 'l-tree-select',
  components: {
    VueEasyTree
  },
  props: {
    value: {},
    placeholder: String,
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    size: {
      type: String,
      default: 'mini'
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filter: {
      type: Boolean,
      default: true
    },
    defaultExpandAll: {
      type: Boolean,
      default: true
    },
    parent: {
      type: Boolean,
      default: true
    },
    lazy: {
      type: Boolean,
      default: false
    },
    getValue: Function,
    treeLoad: Function,
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    disabledList: {
      default: () => {
        return []
      }
    },
    disabledKey: {
      default: 'id'
    },
    tprops: Object,
    'popper-class': {
      default: ''
    },
    dataCode: {
      default: ''
    },
    dataType: {
      default: ''
    },
    isQuery: { // 是否用作查询控件
      default: false
    }
  },
  watch: {
    value: {
      handler() {
        this.initValue()
      },
      immediate: true
    },
    options() {
      this.$nextTick(() => {
        this.setLabel()
      })
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  data() {
    return {
      value2: '',
      labelText: [''],
      filterText: '',
    };
  },
  mounted() {
    this.filterText = ''
  },

  computed: {
    labelShow() {
      return (this.labelText || []).join(SHOW_SPLIT).toString()
    },
    treeProps() {
      return this.tprops || {
        label: this.labelKey,
        children: 'children',
        disabled: 'disabled',
        isLeaf: 'isLeaf'
      }
    },
    isCanAddDataItem() {
      return this.dataCode && !this.disabled && this.dataType != '3' && !this.isQuery
    },
  },
  methods: {
    add() {
      this.$cateManageDg.show({
        code: this.dataCode,
      })
    },
    handleVisibleChange(e) {
      this.$emit("visibleChange", e);
    },
    focus() {
      console.log(this.$refs.main,"9============")
      this.$refs.main.toggleMenu()
    },
    initValue() {
      this.value2 = this.value
      this.$nextTick(() => {
        this.setLabel()
      })
    },
    handleClear() {
      this.value2 = undefined
      this.labelText = []
      this.$emit("input", '')
      this.$emit('clear')
      this.$emit("change", undefined)
    },
    setLabel() {
      if (validatenull(this.value2)) {
        this.labelText = []
      }
      else if (this.options && this.$refs.tree) {
        const node = this.$refs.tree.getNode(this.value2)
        if (node) {
          this.labelText = [node.data[this.labelKey]]
        }
        else if (typeof this.getValue == 'function') {
          this.getValue(this.value2, v => {
            this.labelText = [v]
          })
        }
        else {
          this.labelText = [this.value2] // 找不到值显示原值
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleTreeLoad(node, resolve) {
      let callback = (list) => {
        resolve(list);
      }
      this.treeLoad && this.treeLoad(node, callback)
    },
    handleNodeClick(data) {
      if (data.disabled || this.disabledList.includes(data[this.disabledKey])) return
      if (this.$validatenull(data['children']) || this.parent) {
        const value = data[this.valueKey]
        //const label = data[this.labelKey];
        const result = value //this.multiple ? value.join(",") : value;
        this.value2 = value
        this.node = [data]
        this.$refs.main.blur()

        this.$emit("input", result)
        this.$emit("change", data)
      }
    },
    handleNodeCheck(data, q) {
      console.log(data, q)
    },
    // 初始化滚动条
    handleClick(event) {
      bindEvent(this, 'click', event)
    },
    initScroll(event) {
      setTimeout(() => {
        this.$nextTick(() => {
          let scrollBar = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')
          scrollBar.forEach(ele => {
            ele.scrollTop = 0
          })
        })
      }, 0)
      this.handleClick(event)
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
